module.exports = __webpack_public_path__ + "img/default_email_footer.67467eb9.png";